<template functional>
	<div class="product-text-wrapper">
		<div v-if="props.description && props.description.length > 0">
			<h2 class="pdp-wrapper__h2">
				Description
			</h2>
			<hr />
			<p v-if="props.description">
				{{ props.description }}
			</p>
		</div>
		<div v-if="props.features && props.features.length > 0">
			<h2 class="pdp-wrapper__h2">
				Features
			</h2>
			<hr />
			<ul class="bullet-list">
				<li
					v-for="(feature, index) in props.features"
					:key="index"
					v-show="feature"
				>
					{{ feature }}
				</li>
			</ul>
		</div>
		<div v-if="props.specs && props.specs.length > 0">
			<h2 class="pdp-wrapper__h2">
				Specifications
			</h2>
			<ul class="bullet-list">
				<li
					v-for="(spec, index) in props.specs"
					:key="index"
					v-show="spec"
				>
					{{ spec }}
				</li>
			</ul>
		</div>
		<div v-if="props.documents && props.documents.length > 0" id="pdfDocuments">
			<h2 class="pdp-wrapper__h2">
				Documents
			</h2>
			<ul class="bullet-list">
				<li
					v-for="(document, index) in props.documents"
					:key="index"
					v-show="document"
					class="pdf-document flex-row"
				>
					<img src="/assets/images/icons/iconPDF.png" alt="" />
					<a :href="document.url" target="_blank" rel="noopener noreferrer">{{ document.title }}</a>
				</li>
			</ul>
		</div>
		<div v-if="props.warranties">
			<h2 class="pdp-wrapper__h2">
				Warranty
			</h2>
			<div v-html="props.warranties"></div>
		</div>
	</div>
</template>

<script>
export default {
	name: "ProductText",
	props: {
		description: [Array, String],
		features: [Array, String],
		specs: [Array, String],
		warranties: [Array, String],
		documents: [Array, Object],
	},
};
</script>